// extracted by mini-css-extract-plugin
var _1 = "io6Hlz8flc0Z1I7VrFts";
var _2 = "io6Hlz8flc0Z1I7VrFts";
var _3 = "veJq8d1vzCHYO64O_SlI";
var _4 = "veJq8d1vzCHYO64O_SlI";
var _5 = "_M9s8cdfWEsKJUxoEWXw";
var _6 = "_M9s8cdfWEsKJUxoEWXw";
export { _1 as "add-work-button", _2 as "addWorkButton", _3 as "form-bottom-margin", _4 as "formBottomMargin", _5 as "no-bottom-padding", _6 as "noBottomPadding" }
